export default __webpack_public_path__ + "static/greenshield_pass-4faabfa8e48465b5775ba6236e63c25a.png";